<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>质保卡产品</h4>
      </div>
      <div class="c-flex c-flex-item">
        <div>
          <el-select
            v-model="searchStateValue"
            collapse-tags
            class="c-m-r-10"
            filterable
            multiple
            clearable
            placeholder="适用防水指实物产品"
            size="small"
            style="width:100%"
            @change="
              fpi.page = 1;
              getData();
            "
          >
            <el-option
              v-for="(item, i) in options.productBizType"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <el-input
          placeholder="请输入名称/型号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          @click="doNew(1)"
          class="c-m-l-10"
          v-if="osg.has('WarrantyProducts,add')"
        >
          新增
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          v-if="osg.has('WarrantyProducts,export')"
          @click="
            osg.doExport(
              {
                'in:state|integer#and': 1,
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'all:productList|array#and': searchStateValue.join(','),
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'warrantyProduct',
                title: '质保卡产品'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('WarrantyProducts,edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('WarrantyProducts,remove')"
                    @click.native="doRemove(scope.row)"
                  >
                    删除
                  </el-dropdown-item>
                  <!-- <el-dropdown-item
                    v-if="osg.has('WarrantyProducts,able') && scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('WarrantyProducts,able') && scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item> -->
                  <!-- <el-dropdown-item
                    v-if="osg.has('WarrantyProducts,archive') && state != 'archived'"
                    @click.native="doArchive(scope.row, '归档')"
                  >
                    归档
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('WarrantyProducts?state=archived,recover') && state == 'archived'"
                    @click.native="doArchive(scope.row, '恢复')"
                  >
                    恢复
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <c-table :fields="extFields">
            <!-- <template slot="name">
              <el-table-column label="名称" width="160" fixed="left" show-overflow-tooltip>
                <template slot-scope="scope" style="width:100%">
                  <el-button
                    type="text"
                    @click="
                      $router.push({
                        path: `/WarrantyProduct/${scope.row._id}`
                      })
                    "
                  >
                    {{ osg.codelabel('warrantyProductCard', scope.row.name) }}
                  </el-button>
                </template>
              </el-table-column>
            </template> -->
          </c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="质保卡产品信息"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :upload="upload"
        :fields="extFields"
        :options="options"
        ref="form"
        @changeForm="osg.changeForm"
      >
        <template slot="price">
          <el-input
            type="number"
            :disabled="formData.exts.promotion !== '1'"
            placeholder="请输入"
            v-model="formData.price"
          ></el-input>
        </template>
        <template slot="years">
          <el-select v-model="formData.years" @change="changeYears" placeholder="请选择">
            <el-option
              v-for="item in options.warrantyPeriod"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <!-- <template slot="exts.promotion">
          <el-select
            v-model="formData.exts.promotion"
            @change="changeYears"
            placeholder="请选择"
            v-if="true || osg.has('WarrantyProduct,promotion')"
          >
            <el-option
              v-for="item in options['IS']"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->
        <!-- <template slot="productList">
          <el-select
            v-model="formData.productList"
            @change="$forceUpdate()"
            @clear="getProduct"
            clearable
            multiple
            remote
            :remote-method="getProduct"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options.product"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->
        <!-- <template slot="countryUse">
          <el-select v-model="formData.countryUse" clearable placeholder="请选择">
            <el-option
              v-for="item in options.isNational"
              :key="item.value"
              :label="item.label"
              :value="(item.value)"
            ></el-option>
          </el-select>
        </template> -->
        <!-- <template slot="orgIds">
          <el-cascader
            v-model="formData.orgIds"
            :options="options.orgs"
            :show-all-levels="false"
            :props="{
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            clearable
          ></el-cascader>
        </template> -->
      </c-form>
      <el-form label-position="left" :model="formData" ref="formDataDesc" label-width="90px">
        <el-form-item
          label="描述"
          prop="description"
          :rules="{
            required: formData.exts.promotion === '1',
            trigger: 'blur',
            message: '描述不能为空'
          }"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
            placeholder="请输入"
            v-model="formData.description"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'WarrantyProducts',
  data() {
    return {
      name: 'warrantyProduct',
      fpi: {},
      searchValue: '',
      searchStateValue: [],
      openDetail: false,
      formData: { exts: {}, productList: [] },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      options: {
        codecfg_IS: { codeId: 'IS' },
        codecfg_warrantyProductCard: { codeId: 'warrantyProductCard' }, //质保年限
        codecfg_warrantyPeriod: { codeId: 'warrantyPeriod' }, //质保卡产品名称
        codecfg_fixedLifePrice: { codeId: 'fixedLifePrice' }, //质保卡年限固定价格表
        codecfg_productBizType: { codeId: 'productBizType' } //产品code
      },
      state: '', //已归档 archived
      refresh: true //表格刷新
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();
    this.getProduct();
    this.getOrgs();
    this.osg.getFields('warrantyProduct', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.formData = { exts: { promotion: '0' }, productList: [] };
      this.openDetail = false;
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|integer#and': 1,
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'all:productList|array#and': this.searchStateValue.join(','),
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/warrantyProduct/query.do', params, res => {
        this.refresh = false;
        this.fpi = res;
        this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //更改质保年限
    changeYears(val) {
      this.driveForm(val);
    },
    // 根据质保年限驱动表单字段
    driveForm(val) {
      let warrantyProductCardData = this.options.warrantyProductCard.find(
        item => item.value == val
      );
      let fixedLifePrice = this.options.fixedLifePrice.find(item => item.label == val).value; //质保卡年限固定价格表
      let warrantyPeriodData = this.options.warrantyPeriod.find(item => item.value == val);
      this.$set(this.formData, 'name', warrantyProductCardData.label);
      this.$set(this.formData.exts, 'nameCode', warrantyProductCardData.value);
      this.$set(this.formData, 'code', val);
      this.$set(this.formData.exts, 'codelabel', warrantyPeriodData.label);
      this.$set(this.formData, 'price', +fixedLifePrice);
      this.$set(this.formData, 'unit', '1');
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      row.exts.promotion = row.exts.promotion || '0';
      this.formData = row;
      this.openDetail = true;
    },
    doRemove(row) {
      this.osg.confirm(`确定要删除${row.name}吗？`, () => {
        this.osg.ajax(`basic/warrantyProduct/remove/${row._id}.do`, null, () => {
          this.doInit();
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    doSave() {
      if (this.osg.isRepeatClick('doSave', 5000)) {
        return;
      }
      if (this.osg.validate() && this.osg.validate('formDataDesc')) {
        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax(
          'basic/warrantyProduct/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    getProduct(query) {
      let params = {
        _all: '1',
        'regex:name|string#or': query,
        'in:state|array-integer#and': '1',
        'ne:productType|string#and': ''
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.product = res.data;
        this.$forceUpdate();
      });
    },
    getOrgs(orgIds, resolve) {
      this.osg.ajax(
        'org/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          'in:_id|array#and': orgIds,
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          res.data.orgName = '全部';
          this.options.orgs = [res.data];
          if (resolve) resolve();
        },
        {
          noload: true
        }
      );
    }
    // doEnable(id) {
    //   this.osg.ajax('basic/warrantyProduct/enable/' + id + '.do', null, () => {
    //     this.getData();
    //     this.osg.toast('操作成功！');
    //   });
    // },
    // doDisable(id) {
    //   this.osg.ajax('basic/warrantyProduct/disable/' + id + '.do', null, () => {
    //     this.getData();
    //     this.osg.toast('操作成功！');
    //   });
    // },
    // doArchive(row, msg) {
    //   this.osg.confirm(`是否确认${msg}客户 ${row.name}？`, () => {
    //     this.osg.ajax('basic/warrantyProduct/archive/' + row._id + '.do', null, () => {
    //       this.getData();
    //       this.osg.toast(`已${msg}客户 ${row.name}`);
    //     });
    //   });
    // }
  }
};
</script>
